import {number} from "ngx-custom-validators/src/app/number/validator";
import { Injectable } from '@angular/core';

interface RateTableEntry {
  netPremium: number;
  sellingRateExclIpt: number;
  sellingRateInclIpt: number;
  totalCommission: number;
  brokerPayAway: number;
}

// TODO: This needs to be a database table.
const HORSEBOX_RATES: { [key: string]: RateTableEntry } = {
  '0-10_upto7.5': {
    netPremium: 117.96,
    sellingRateExclIpt: 141.96,
    sellingRateInclIpt: 159.00,
    totalCommission: 24.00,
    brokerPayAway: 12.00
  },
  '0-10_over7.5': {
    netPremium: 167.96,
    sellingRateExclIpt: 202.68,
    sellingRateInclIpt: 227.00,
    totalCommission: 34.72,
    brokerPayAway: 17.36
  },
  '11+_upto7.5': {
    netPremium: 169.52,
    sellingRateExclIpt: 206.25,
    sellingRateInclIpt: 231.00,
    totalCommission: 36.73,
    brokerPayAway: 18.37
  },
  '11+_over7.5': {
    netPremium: 219.52,
    sellingRateExclIpt: 268.75,
    sellingRateInclIpt: 301.00,
    totalCommission: 49.23,
    brokerPayAway: 24.62
  },
};

@Injectable({
  providedIn: 'root'
})
export class BreakdownCalculations {
  net_rate: number = 0.0;
  full_class_net_rate_amount: number = 0.0;
  full_main_discount: number = 0.0;
  full_class_gross_amount: number = 0.0;
  full_ipt_gross_amount: number = 0.0;
  full_total_gross_primum: number = 0.0;
  full_total_premium: number = 0.0;
  full_total_amount_payable: number = 0.0;
  full_broker_amount: number = 0.0;
  full_pay_away_amount: number = 0.0;
  full_peliwica_retained_amount: number = 0.0;
  full_net_Premium_amount = 0.0;


  broker_commission: number = 0.0;
  peliwica_pay_away_commission: number = 0.0;
  peliwica_retained_commission: number = 0.0;
  ipt_fee: number = 0.0;
  full_underwriting_fee: number = 0.0;
  broker_admin_fee: number = 0.0;

  sum_insured: number = 0.0;
  policy_minimum_premium: number = 0.0;


  premium_loading: number = 0;
  total_premium_loading: number = 0;
  premium_loading_percentage: number = 0;
  is_mta: boolean = false;
  is_cancel: boolean = false;
  is_lapse: boolean = false;
  is_NTU: boolean = false;
  mta_date;

  old_premium_loading_percentage: number = 0;
  clearStatus: boolean = false;

  constructor() {

  }

  public calculatePremium(vehicleYear: number, vehicleWeight: number): object | null {
    const currentYear = new Date().getFullYear();
    const age = currentYear - vehicleYear;
    const ageKey = age <= 10 ? '0-10' : '11+';
    const weightKey = vehicleWeight <= 7.5 ? 'upto7.5' : 'over7.5';
    const rateKey = `${ageKey}_${weightKey}`;

    const rates = HORSEBOX_RATES[rateKey];

    if (!rates) {
      console.error(`No rates found for key: ${rateKey}`);
      return null;
    }

    // Populate based on the lookup
    this.net_rate = rates.netPremium;
    this.full_net_Premium_amount = rates.netPremium;

    // Assuming "Selling Rate to Customer (Excl IPT)" is the base for gross amount before IPT
    this.full_class_gross_amount = rates.sellingRateExclIpt;

    // Calculate IPT amount (Selling Rate Incl IPT - Selling Rate Excl IPT)
    this.full_ipt_gross_amount = parseFloat((rates.sellingRateInclIpt - rates.sellingRateExclIpt).toFixed(2));

    // Total Premium (Incl IPT)
    this.full_total_gross_primum = rates.sellingRateInclIpt;
    this.full_total_premium = rates.sellingRateInclIpt;
    this.full_total_amount_payable = rates.sellingRateInclIpt;

    // Commission details
    this.broker_commission = rates.totalCommission;
    this.full_broker_amount = rates.totalCommission;

    // Pay away (Broker share)
    this.full_pay_away_amount = rates.brokerPayAway;
    this.peliwica_pay_away_commission = rates.brokerPayAway;

    // Retained (Peliwica share = Total Commission - Broker Pay Away)
    this.peliwica_retained_commission = rates.totalCommission - rates.brokerPayAway;
    this.full_peliwica_retained_amount = this.peliwica_retained_commission;

    // Calculate IPT amount
    const iptAmount = parseFloat((rates.sellingRateInclIpt - rates.sellingRateExclIpt).toFixed(2));

    return {
      referred: null,
      ipt: iptAmount,                              // Insurance Premium Tax amount
      gross: rates.sellingRateExclIpt,             // Premium excluding IPT
      breakdown_ipt: iptAmount,
      breakdown_gross: rates.sellingRateExclIpt,
      total_amount: rates.sellingRateInclIpt,      // Total premium including IPT
      gross_premium: rates.sellingRateExclIpt,     // Premium excluding IPT (for display)
      grossPremium: rates.sellingRateInclIpt,      // Total (HTML subtracts IPT from this)
      vehicle_premiums: {},
      netPremium: rates.netPremium,
      totalCommission: rates.totalCommission,
      brokerPayAway: rates.brokerPayAway,
      peliwicaFee: 0,                              // Peliwica fee
    };
  }


}
